if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach(gallery => {
    const viewerComponent = gallery.querySelector('slider-component#GalleryViewer-' + gallery.id.split('-')[1])
                         || gallery.querySelector('slider-component'); // fallback
    if (!viewerComponent) return;

    const slideTrack = viewerComponent.querySelector('.product__media-list.slider');
    if (!slideTrack) return;

    const slides = Array.from(slideTrack.querySelectorAll('.slider__slide'));
    if (!slides.length) return;

    const dotsContainer = viewerComponent.querySelector('.slider-dots');
    const dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('.dot')) : [];
    const nextBtn = viewerComponent.querySelector('.slider-button--next');
    const prevBtn = viewerComponent.querySelector('.slider-button--prev');
    const currentCounter = viewerComponent.querySelector('.slider-counter--current');
    const totalCounter = viewerComponent.querySelector('.slider-counter--total');

    const thumbnailsComponent = gallery.querySelector('slider-component#GalleryThumbnails-' + gallery.id.split('-')[1])
                                 || gallery.querySelector('slider-component.thumbnail-slider');
    const thumbnailList = thumbnailsComponent ? thumbnailsComponent.querySelector('.thumbnail-list') : null;
    const thumbnailItems = thumbnailList ? Array.from(thumbnailList.querySelectorAll('.thumbnail-list__item')) : [];
    const thumbnailButtons = thumbnailList ? Array.from(thumbnailList.querySelectorAll('button.thumbnail')) : [];

    const slideIdToIndex = {};
    slides.forEach((s, i) => {
      const id = s.dataset.mediaId || s.getAttribute('data-media-id') || s.id;
      slideIdToIndex[id] = i;
    });

    if (totalCounter) totalCounter.textContent = slides.length;

    let activeIndex = 0;
    const initiallyActive = slides.findIndex(s => s.classList.contains('is-active'));
    if (initiallyActive >= 0) activeIndex = initiallyActive;

    const SCROLL_DEBOUNCE = 80;
    let scrollTimeout = null;

    function setActiveDot(i) {
      if (dots.length) {
        dots.forEach((d, idx) => {
          d.classList.toggle('active', idx === i);
          if (idx === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      if (currentCounter) currentCounter.textContent = i + 1;
    }

    function setActiveThumbnail(i) {
      if (!thumbnailItems.length) return;
      thumbnailItems.forEach((item, idx) => {
        item.classList.toggle('is-active', idx === i);
        const btn = item.querySelector('button.thumbnail');
        if (btn) {
          if (idx === i) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        }
      });
      const activeThumb = thumbnailItems[i];
      if (activeThumb && thumbnailList) {
        const thumbRect = activeThumb.getBoundingClientRect();
        const listRect = thumbnailList.getBoundingClientRect();
        const target = (activeThumb.offsetLeft) - (thumbnailList.clientWidth / 2) + (activeThumb.clientWidth / 2);
        thumbnailList.scrollTo({ left: Math.round(target), behavior: 'smooth' });
      }
    }

    function getSlideLeftRelativeToTrack(slide) {
      const slideRect = slide.getBoundingClientRect();
      const trackRect = slideTrack.getBoundingClientRect();
      return (slideRect.left - trackRect.left) + slideTrack.scrollLeft;
    }

    function goToSlide(index, smooth = true) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      const targetLeft = getSlideLeftRelativeToTrack(slides[index]);
      slideTrack.scrollTo({ left: Math.round(targetLeft), behavior: smooth ? 'smooth' : 'auto' });
      activeIndex = index;
      setActiveDot(activeIndex);
      setActiveThumbnail(activeIndex);
      slides.forEach((s, i) => s.classList.toggle('is-active', i === activeIndex));
    }

    if (dots.length) {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.getAttribute('data-slide'), 10);
          if (!Number.isNaN(idx)) goToSlide(idx);
        });
      });
    }

    if (thumbnailButtons.length) {
      thumbnailButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const parent = btn.closest('.thumbnail-list__item');
          const targetId = parent ? (parent.getAttribute('data-target') || parent.dataset.target) : null;
          if (targetId && targetId in slideIdToIndex) {
            goToSlide(slideIdToIndex[targetId]);
          } else {
            const pos = parent ? parseInt(parent.getAttribute('data-media-position'), 10) : NaN;
            if (!Number.isNaN(pos)) goToSlide(Math.max(0, pos - 1));
          }
          e.preventDefault();
        });
      });
    }

    function move(dir) {
      goToSlide((activeIndex + dir + slides.length) % slides.length);
    }
    if (nextBtn) nextBtn.addEventListener('click', () => move(1));
    if (prevBtn) prevBtn.addEventListener('click', () => move(-1));

    slideTrack.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const currentScroll = slideTrack.scrollLeft;
        let closest = 0;
        let closestDist = Infinity;
        slides.forEach((s, i) => {
          const left = getSlideLeftRelativeToTrack(s);
          const dist = Math.abs(left - currentScroll);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        if (closest !== activeIndex) {
          activeIndex = closest;
          setActiveDot(activeIndex);
          setActiveThumbnail(activeIndex);
          slides.forEach((s, i) => s.classList.toggle('is-active', i === activeIndex));
        }
      }, SCROLL_DEBOUNCE);
    }, { passive: true });

    goToSlide(activeIndex, false);

    viewerComponent.setAttribute('tabindex', viewerComponent.getAttribute('tabindex') || '0');
    viewerComponent.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') move(1);
      if (e.key === 'ArrowLeft') move(-1);
    });
  });
});
